import React, { SetStateAction, useState } from "react";
import { Datepicker, locale } from "@mobiscroll/react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  IconButton,
  Typography
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import useTimeFormat from "../../../hooks/useTimeFormat/useTimeFormat";
import { DateRange } from "../../Reports/SupervisorReport/supervisor-report.component";

export interface DatePickerDialogProps {
  open: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  dates: { start: string; end: string };
  onChangeDateRange: (range: DateRange) => void;
}

export const DatePickerDialog: React.FC<DatePickerDialogProps> = ({
  open,
  setOpen,
  dates,
  onChangeDateRange
}) => {
  const { t, i18n } = useTranslation();
  const { dateFormat } = useTimeFormat();

  const [pickDate, setPickDate] = useState<{ start: string; end: string }>(dates);

  const handleCancel = () => {
    setOpen(false);
    setPickDate(dates);
  };
  const handleConfirm = () => {
    setOpen(false);
    onChangeDateRange({ start: pickDate.start, end: pickDate.end });
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="simple-dialog-title"
      slotProps={{ paper: { sx: { minWidth: "200px", py: 1 } } }}
    >
      <Grid2 container data-testid="date-picker-dialog-header" flexDirection={"row"}>
        <Grid2 size={"grow"} />
        <Grid2 size={{ xs: 9 }} sx={{ alignContent: "center" }}>
          <Typography align={"center"}>{t("Change timeframe")}</Typography>
        </Grid2>
        <Grid2 size={"grow"} sx={{ textAlign: "right" }}>
          <IconButton
            sx={{ float: "right" }}
            data-testid="date-picker-close-btn"
            onClick={handleCancel}
            size="large"
          >
            <Close />
          </IconButton>
        </Grid2>
      </Grid2>

      <DialogContent sx={{ px: 3, py: 1 }}>
        <Datepicker
          label={t("Start")}
          max={pickDate.end}
          value={pickDate.start}
          onChange={ev =>
            setPickDate({
              start: ev.value ? (DateTime.fromJSDate(ev.value as Date).toISO() as string) : "",
              end: pickDate.end
            })
          }
          dateFormat={dateFormat.toUpperCase()}
          locale={locale[i18n.language]}
        />
        <Datepicker
          label={t("End")}
          min={pickDate.start}
          value={pickDate.end}
          onChange={ev =>
            setPickDate({
              start: pickDate.start,
              end: ev.value ? (DateTime.fromJSDate(ev.value as Date).toISO() as string) : ""
            })
          }
          dateFormat={dateFormat.toUpperCase()}
          locale={locale[i18n.language]}
        />
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center" }}>
        <Button onClick={handleConfirm} data-testid="date-picker-confirm-btn">
          {t("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
